var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observable } from 'rxjs';
import { map, tap, flatMap } from 'rxjs/operators';
import { Api } from 'app/core/api.service';
import { ApplicationsService } from 'app/applications/applications.service';
import { fullName } from 'app/core/service-type.model';
import { Order, OrderError } from './order.model';
import { ISOStringForCurrentTime } from 'app/core/date/functions';
var OrderService = /** @class */ (function () {
    function OrderService(_api, _applicationsService) {
        this._api = _api;
        this._applicationsService = _applicationsService;
    }
    OrderService.prototype.create = function (settings, serviceType) {
        var _this = this;
        var linkServiceType = fullName(serviceType);
        var applicationId = settings.application
            ? settings.application.id
            : undefined;
        var headers = this._applicationsService.headers(applicationId);
        var properties = {};
        if (settings.verification) {
            properties.verification_type = settings.verification;
        }
        if (serviceType === 'ic') {
            properties.region = settings.region;
            properties.export_format = settings.export_format;
        }
        else {
            var _temp = Object.assign({}, settings);
            delete _temp.serviceType;
            delete _temp.verification;
            delete _temp.files;
            Object.assign(properties, _temp);
        }
        return this._api
            .post("/v2/task/capture/" + linkServiceType, {
            files: settings.files,
            properties: properties
        }, { headers: headers })
            .pipe(flatMap(function (response) { return _this.get(response.id); }));
    };
    /** Возвращает заказ по его идентификатору */
    OrderService.prototype.get = function (orderId, application) {
        if (application === void 0) { application = this._applicationsService.defaultApplication(); }
        var headers = this._applicationsService.headers(application.id);
        return this._api
            .get("/v2/task/" + orderId, { headers: headers })
            .pipe(map(function (response) { return new Order(response); }));
    };
    /** Возвращает ошибки таски */
    OrderService.prototype.getError = function (orderId, applicationId) {
        if (applicationId === void 0) { applicationId = this._applicationsService.defaultApplication().id; }
        var headers = this._applicationsService.headers(applicationId);
        return this._api.get("/v2/task/" + orderId + "/error", { headers: headers }).pipe(map(function (response) { return (__assign({}, response, { errors: response.errors.map(function (error) { return new OrderError(error); }) })); }));
    };
    /** Удаляет заказ */
    OrderService.prototype.remove = function (order) {
        var headers = this._applicationsService.headers(order.application);
        return this._api
            .delete("/v2/task/" + order.id, { headers: headers })
            .pipe(tap(function () { return (order.status = 'Deleted'); }));
    };
    /** Отмечает, что заказ проверифицирован и помещает его в статус InProgress */
    OrderService.prototype.verified = function (orderId, applicationId) {
        var headers = this._applicationsService.headers(applicationId);
        return this._api.put("/v2/task/" + orderId + "/action/complete", null, {
            headers: headers
        });
    };
    /** Получает статистику для usage report */
    OrderService.prototype.consumptionMonthly = function (serviceType, from, to) {
        if (serviceType === void 0) { serviceType = null; }
        var _to = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59);
        var params = {
            from: ISOStringForCurrentTime(from),
            to: ISOStringForCurrentTime(_to)
        };
        if (serviceType) {
            return this._api.get("/v2/task/" + serviceType + "/consumption/monthly", {
                params: params
            });
        }
        else {
            return this._api.get("/v2/task/consumption/monthly", {
                params: params
            });
        }
    };
    /** Отмечает, что заказ проверифицирован и помещает его в статус InProgress */
    OrderService.prototype.publicVerified = function (verificationId) {
        return this._api.put("/v2/task/action/complete?verificationId=" + verificationId);
    };
    return OrderService;
}());
export { OrderService };
